import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_Footer.scss'
import SecondaryActionButton from '../../Buttons/SecondaryActionButton'
import FontAwesome from 'react-fontawesome'
import isEmpty from 'lodash/fp/isEmpty'
import React from 'react'
import { Container, Row, Col, Nav} from 'react-bootstrap'

const Footer = ({
  footerMenu,
  footerElements,
  legalLinks,
  publicPortalUrl,
  contactPage,
  navigationLinksFetched,
  investNow,
  activeMenu,
  setActiveMenu
}) => (
  <div>
    <div className={styles['footer-invest-container']}>
      <Container className={styles['footer-container']}>
        {navigationLinksFetched && <Row>
          <Col xs={12} sm={12} md={12} lg={12} >
            <Row>
              <Col xs={6} sm={12} md={12} lg={12} 
              className={`offset-xs-3 ${styles['footer-menu-call-to-action']}`}>
                <SecondaryActionButton
                  onClick={investNow}
                  size={'medium'}
                  buttonText={'Invest now'}
                  className={styles['footer-menu-call-to-action-button']} />
              </Col>
            </Row>
          </Col>
          </Row>}
      </Container>
    </div>
    <div className={styles['footer-desktop']}>
      <div className={styles['footer-headings-container']}>
        <Container className={styles['footer-container']}>
          {navigationLinksFetched && !isEmpty(footerMenu) && <Row>
              {footerMenu.map((menu, index) => {
                return <Col key={index} xs={12} sm={3} md={3} lg={3} >
                  <h5>{menu.Name}</h5>
                </Col>
              })}
            <Col xs={12} sm={3} md={3} lg={3}>
              <h5>{footerElements.ContactHeading}</h5>
            </Col>
            </Row>}
        </Container>
      </div>
      <div className={styles['footer-list-container']}>
        <Container className={styles['footer-container']}>
          {navigationLinksFetched && !isEmpty(footerMenu) && <Row>
              {footerMenu.map((menu, index) => {
                return <Col key={index} xs={12} sm={3} md={3} lg={3} >
                  <ul>
                    {!isEmpty(menu.Links) && menu.Links.map((link, index) => {
                      return <li key={index}>
                        <a href={`${publicPortalUrl}${link.Link}`}>{link.Name}</a>
                      </li>
                    })}
                  </ul>
                </Col>
              })}
            <Col xs={12} sm={3} md={3} lg={3} >
              <ul>
                <li>
                  <a href={`tel:${footerElements.ContactNumber}`}>{footerElements.ContactNumber}</a>
                </li>
                <li>
                  <a href={`${publicPortalUrl}${contactPage.Link}`}>All contact details</a>
                </li>
              </ul>
            </Col>
            </Row>}
        </Container>
      </div>
    </div>
    <div className={styles['footer-mobile']}>
      <div>
        {navigationLinksFetched && !isEmpty(footerElements) && <div>
          <div className={styles['footer-mobile-heading']}>
            <h5>{footerElements.ContactHeading}</h5>
          </div>
          <div className={styles['footer-mobile-list']}>
            <ul>
              <li>
                <a href={`tel:${footerElements.ContactNumber}`}>{footerElements.ContactNumber}</a>
              </li>
              <li>
                <a href={`${publicPortalUrl}${contactPage.Link}`}>All contact details</a>
              </li>
            </ul>
          </div>
          </div>}
        <Nav variant='pills' className="flex-column">
          {navigationLinksFetched && !isEmpty(footerMenu) && <div>
              {footerMenu.map((menu, index) => {
                return <div key={index} >
                  <div className={styles['footer-mobile-heading']}>
                    <Nav.Item
                      onClick={() => setActiveMenu(menu.Name)}>
                      {menu.Name}
                      <FontAwesome name={activeMenu === menu.Name ? 'chevron-up' : 'chevron-down'} />
                    </Nav.Item>
                  </div>
                  {activeMenu === menu.Name &&
                    <div className={styles['footer-mobile-list']}>
                      <ul>
                        {!isEmpty(menu.Links) && menu.Links.map((link, index) => {
                          return <a key={index}
                            href={`${publicPortalUrl}${link.Link}`}>
                            {link.Name}
                          </a>
                        })}
                      </ul>
                    </div>}
                </div>
              })}
            </div>}
        </Nav>
      </div>
    </div>
    <div className={styles['footer-legal-background']}>
      <Container className={styles['footer-container']}>
        <Row className={styles['footer-legal']}>
          {navigationLinksFetched && !isEmpty(footerElements) && <Col xs={12} sm={6} md={6} lg={6} >
              {footerElements.CopyrightText}
            </Col>}
          {navigationLinksFetched && !isEmpty(legalLinks) && <Col xs={12} sm={6} md={6} lg={6} >
            <span className={styles['footer-legal-links']}>
              {legalLinks.map((legalLink, index) => {
                return <span key={index}>
                  <a href={`${publicPortalUrl}${legalLink.Link}`}>{legalLink.Name}</a>
                  {index < legalLinks.length - 1 && <span>&nbsp;|&nbsp;</span>}
                </span>
              })}
            </span>
            </Col>}
        </Row>
      </Container>
    </div>
  </div>
  )

Footer.propTypes = {
  footerMenu: PropTypes.array,
  footerElements: PropTypes.object,
  contactPage: PropTypes.object,
  legalLinks: PropTypes.array,
  publicPortalUrl: PropTypes.string.isRequired,
  navigationLinksFetched: PropTypes.bool.isRequired,
  investNow: PropTypes.func,
  activeMenu: PropTypes.string,
  setActiveMenu: PropTypes.func.isRequired
}

export default (Footer)
